import {
	GetMessagesParams,
	MessageSubject,
} from './types/messageTypes';


export const getURLStumpFromObjectType = (objectType: MessageSubject) => {
	switch (objectType) {
		case 'Organization':
			return 'orgs';
		case 'User':
			return 'users';
		case 'DataSource':
			return 'sources';
		case 'DataCatalog':
			return 'catalogs';
		case 'Dataset':
			return 'datasets';
		case 'DataColumn':
			return 'columns';
		case 'DataRow':
			return 'rows';
		case 'DataValue':
			return 'values';
		case 'DataType':
			return 'types';
		case 'Metric':
			return 'metrics';
		case 'Fact':
			return 'facts';
		case 'Insight':
			return 'insights';
		case 'Domain':
			return 'domains';
		case 'Entity':
			return 'entities';
		case 'Attribute':
			return 'attributes';
		case 'Individual':
			return 'individuals';
	}
};

export const buildMessagesQueryURL = ({
	objectId,
	objectType,
	perPage = 10,
	page = 1
}: GetMessagesParams) =>
	`/${getURLStumpFromObjectType(objectType)}/${objectId}/messages?page=${page}&per_page=${perPage}`;

export const buildParametrizedMessagesQueryURL = (
	objectType: MessageSubject
) => `/${getURLStumpFromObjectType(objectType)}/:objectId/messages?page=:page&per_page=:perPage`;
